module.exports = __webpack_public_path__ + "img/no-lock.df6d590b.svg";